// extracted by mini-css-extract-plugin
module.exports = {"weSocials":"F7i9","header":"F7ap","list":"F7ar","link":"F7ch"};